import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  StaticPage,
  StoreDetail,
} from 'src/app/modules/shared/models/store-details.model';
import { DynamicMetaService } from 'src/app/modules/shared/services/dynamic-meta.service';
import { StoreDetailService } from 'src/app/modules/shared/services/resolver/store-detail.service';

@Component({
  selector: 'app-static',
  templateUrl: './static.component.html',
  styleUrls: ['./static.component.scss'],
})
export class StaticComponent implements OnInit {
  innerHtml: StaticPage;
  storeDetail: StoreDetail;
  subscriptions = [];
  metaData: any;
  panelOpenState = false;

  constructor(
    private route: ActivatedRoute,
    private storeDetailResolver: StoreDetailService,
    private dynamicMetaService: DynamicMetaService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.getStoreDetail();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
    if (this.metaData) {
      this.dynamicMetaService.unLoadMeta(this.metaData);
    }
  }

  getStoreDetail() {
    this.storeDetail = this.storeDetailResolver.permissionInit;
    this.setRouteParams();
  }

  setRouteParams() {
    const routeSubscription = this.route.params.subscribe((routeParams) => {
      this.setPageDetail();
    });
    this.subscriptions.push(routeSubscription);
  }

  setPageDetail() {
    let staticPage = this.storeDetail?.static_pages.find((el) => {
      return el.slug == this.route.snapshot.params.page;
    });

    if (staticPage) {
      this.setMetaTags(staticPage);
      this.innerHtml = staticPage;
    }
  }

  private setMetaTags(staticPage: StaticPage) {
    if (!staticPage.meta_tag) return;
    this.metaData = this.dynamicMetaService.loadMeta(staticPage.meta_tag);
  }

  onBack() {
    this.location.back();
  }
}
